import React, { useState, useEffect } from 'react';
import api from '../services/api';

function LichThuMau() {
  const [lichList, setLichList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // (Giữ nguyên) State để lưu danh sách xã
  const [xaPhuongList, setXaPhuongList] = useState([]);

  // (Giữ nguyên) State cho form Thêm/Sửa
  const [showAddForm, setShowAddForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false); 
  const [editingId, setEditingId] = useState(null); 
  
  const [formData, setFormData] = useState({
    ngay_thu: '',
    tram_thu: '1', 
    gio_bat_dau: '',
    gio_ket_thuc: '', 
    dia_diem: '',
    cac_xa_id: [], 
    ghi_chu: '',
    can_bo_thu_mau: '', 
    sdt_lien_he: '' 
  });
  
  // (Giữ nguyên) State cho bộ lọc tìm kiếm
  const [searchParams, setSearchParams] = useState({
     tram_thu: '',
     xa_id: '',
     ngay_thu: ''
  });
  
  const [isSaving, setIsSaving] = useState(false);

  const user = JSON.parse(localStorage.getItem('user'));
  const isAdminUser = user?.role === 'admin';

  // (Giữ nguyên) Tải dữ liệu (Lịch và Xã)
  useEffect(() => {
    fetchData(); // Tải lịch
    fetchXaPhuong(); // Tải danh sách xã
  }, []); 

  // (Giữ nguyên) Hàm tải lịch
  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const queryString = new URLSearchParams(searchParams).toString();
      const res = await api.get(`/lich-thu-mau?${queryString}`); 
      setLichList(res.data);
    } catch (err) {
      console.error(err);
      setError('Không thể tải lịch thu mẫu.');
    } finally {
      setLoading(false);
    }
  };

  // (Giữ nguyên) Hàm tải danh sách xã
  const fetchXaPhuong = async () => {
     try {
        const res = await api.get('/data/xaphuong');
        setXaPhuongList(res.data);
     } catch (err) {
        console.error("Lỗi tải danh sách xã:", err);
     }
  };

  // (Giữ nguyên) Xử lý thay đổi bộ lọc tìm kiếm
  const handleSearchChange = (e) => {
    setSearchParams({ ...searchParams, [e.target.name]: e.target.value });
  };
  
  // (Giữ nguyên) Xử lý khi bấm nút Tìm kiếm
  const handleSearchSubmit = (e) => {
      e.preventDefault();
      fetchData(); 
  };
  
  // (Giữ nguyên) Xử lý khi bấm nút "Sửa"
  const handleEditClick = (lich) => {
      setIsEditing(true); 
      setEditingId(lich.id); 
      setShowAddForm(true); 
      
      setFormData({
          ngay_thu: lich.ngay_thu ? new Date(lich.ngay_thu).toISOString().split('T')[0] : '',
          tram_thu: lich.tram_thu,
          gio_bat_dau: lich.gio_bat_dau,
          gio_ket_thuc: lich.gio_ket_thuc,
          dia_diem: lich.dia_diem,
          cac_xa_id: JSON.parse(lich.cac_xa_id || '[]').map(String), 
          ghi_chu: lich.ghi_chu || '',
          can_bo_thu_mau: lich.can_bo_thu_mau || '',
          sdt_lien_he: lich.sdt_lien_he || ''
      });
  };
  
  // (Giữ nguyên) Hủy chế độ Sửa/Thêm
  const cancelForm = () => {
      setShowAddForm(false);
      setIsEditing(false);
      setEditingId(null);
      setError('');
      setFormData({
          ngay_thu: '', tram_thu: '1', gio_bat_dau: '', gio_ket_thuc: '', 
          dia_diem: '', cac_xa_id: [], ghi_chu: '', 
          can_bo_thu_mau: '', sdt_lien_he: ''
      });
  };

  // (Giữ nguyên) Xử lý thay đổi input form
  const handleFormChange = (e) => {
    const { name, value, type, selectedOptions } = e.target;
    if (name === 'cac_xa_id') {
      const selectedIds = Array.from(selectedOptions).map(option => option.value);
      setFormData({ ...formData, cac_xa_id: selectedIds });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // (*** CẬP NHẬT ***) Xử lý submit form (dùng getXaNames)
  const handleSubmitLich = async (e) => {
    e.preventDefault();
    setError('');
    
     if (!formData.ngay_thu || !formData.tram_thu || !formData.gio_bat_dau || !formData.gio_ket_thuc || !formData.dia_diem || formData.cac_xa_id.length === 0) {
       setError('Vui lòng nhập đầy đủ Ngày, Trạm, Giờ, Địa điểm và chọn ít nhất một Xã.');
       return;
     }
    
    setIsSaving(true);
    
    try {
      if (isEditing) {
        // --- LOGIC SỬA (PUT) ---
        const res = await api.put(`/lich-thu-mau/${editingId}`, formData); 
        // (CẬP NHẬT) Tự tính toán 'ten_cac_xa'
        const tenXaDaChon = getXaNames(res.data.cac_xa_id);
        setLichList(lichList.map(lich => lich.id === editingId ? { ...res.data, ten_cac_xa: tenXaDaChon } : lich));
      } else {
        // --- LOGIC THÊM MỚI (POST) ---
        const res = await api.post('/lich-thu-mau', formData); 
        // (CẬP NHẬT) Tự tính toán 'ten_cac_xa'
         const tenXaDaChon = getXaNames(res.data.cac_xa_id);
        setLichList([{ ...res.data, ten_cac_xa: tenXaDaChon }, ...lichList]); 
      }
      cancelForm(); // Đóng và reset form
      
    } catch (err) {
      setError(err.response?.data?.message || `Lỗi khi ${isEditing ? 'cập nhật' : 'tạo mới'} lịch`);
    } finally {
      setIsSaving(false);
    }
  };

  // (Giữ nguyên) Xử lý xóa lịch
  const handleDeleteLich = async (id) => {
    if (!window.confirm('Bạn có chắc muốn xóa lịch này?')) return;
    try {
      await api.delete(`/lich-thu-mau/${id}`);
      setLichList(lichList.filter(lich => lich.id !== id)); 
    } catch (err) {
      alert('Lỗi: ' + (err.response?.data?.message || 'Không thể xóa lịch'));
    }
  };

  // (Giữ nguyên)
  const formatTime = (timeString) => {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    return `${hours}:${minutes}`;
  };
  
  // (Giữ nguyên)
  const formatDate = (dateString) => {
      if (!dateString) return '';
      try {
          const date = new Date(dateString);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
      } catch (e) {
          return dateString; 
      }
  };

  // (*** MỚI ***) Hàm chuyển đổi [1, 2, 3] sang "Tên Xã 1, Tên Xã 2"
  const getXaNames = (idJsonString) => {
      if (!idJsonString || xaPhuongList.length === 0) return '';
      try {
          // ID được lưu trong CSDL dưới dạng chuỗi JSON: "[1, 5, 10]"
          const ids = JSON.parse(idJsonString).map(String); // Đảm bảo ID là chuỗi
          const names = xaPhuongList
              .filter(xa => ids.includes(String(xa.id))) // So sánh chuỗi với chuỗi
              .map(xa => xa.ten_xa);
          return names.join(', '); // Trả về "An Tảo, Tiên Lữ, Phù Cừ"
      } catch (e) {
          console.error("Lỗi parse JSON xã IDs:", idJsonString, e);
          return 'Lỗi dữ liệu xã';
      }
  };


  if (loading) return <p>Đang tải lịch thu mẫu...</p>;
  if (error && !loading && !showAddForm) return <p style={{ color: 'red' }}>Lỗi: {error}</p>;

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Lịch Thu Mẫu ADN</h1>
        {isAdminUser && !showAddForm && ( 
          <button onClick={() => setShowAddForm(true)} style={{ background: 'green', color: 'white' }}>
            + Thêm Lịch Mới
          </button>
        )}
      </div>
      
      {/* (Giữ nguyên) Form Tìm kiếm */}
      <form onSubmit={handleSearchSubmit} style={{ background: '#f9f9f9', padding: '15px', borderRadius: '8px', marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
         <div>
            <label>Tìm theo Trạm:</label>
            <select name="tram_thu" value={searchParams.tram_thu} onChange={handleSearchChange} style={{width: '100%'}}>
              <option value="">-- Tất cả Trạm --</option>
              <option value="1">Trạm 1</option>
              <option value="2">Trạm 2</option>
              <option value="3">Trạm 3</option>
            </select>
         </div>
         <div>
            <label>Tìm theo Xã:</label>
             <select name="xa_id" value={searchParams.xa_id} onChange={handleSearchChange} style={{width: '100%'}}>
               <option value="">-- Tất cả Xã --</option>
               {xaPhuongList.map(xa => (
                  <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>
               ))}
             </select>
         </div>
         <div>
            <label>Tìm theo Ngày:</label>
            <input type="date" name="ngay_thu" value={searchParams.ngay_thu} onChange={handleSearchChange} style={{width: '100%'}}/>
         </div>
         <button type="submit" style={{ background: '#007bff', color: 'white' }}>Tìm kiếm</button>
         <button type="button" onClick={() => { setSearchParams({ tram_thu: '', xa_id: '', ngay_thu: '' }); fetchData(); }} style={{ background: 'gray', color: 'white' }}>Xóa lọc</button>
      </form>


      {/* (Giữ nguyên) Form Thêm/Sửa lịch */}
      {isAdminUser && showAddForm && (
        <form onSubmit={handleSubmitLich} style={{ background: '#f4f4f4', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3>{isEditing ? 'Sửa Lịch Thu Mẫu' : 'Tạo Lịch Thu Mẫu Mới'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px' }}>
            <div>
              <label>Ngày thu (DD/MM/YYYY):*</label>
              <input type="date" name="ngay_thu" value={formData.ngay_thu} onChange={handleFormChange} required style={{width: '100%'}}/>
            </div>
            <div>
              <label>Trạm thu:*</label>
              <select name="tram_thu" value={formData.tram_thu} onChange={handleFormChange} required style={{width: '100%'}}>
                <option value="1">Trạm 1</option>
                <option value="2">Trạm 2</option>
                <option value="3">Trạm 3</option>
              </select>
            </div>
            <div>
              <label>Giờ bắt đầu:*</label>
              <input type="time" name="gio_bat_dau" value={formData.gio_bat_dau} onChange={handleFormChange} required style={{width: '100%'}}/>
            </div>
            <div>
              <label>Giờ kết thúc:*</label>
              <input type="time" name="gio_ket_thuc" value={formData.gio_ket_thuc} onChange={handleFormChange} required style={{width: '100%'}}/>
            </div>
            <div style={{ gridColumn: 'span 2' }}>
              <label>Địa điểm/Trạm thu:*</label>
              <input type="text" name="dia_diem" value={formData.dia_diem} onChange={handleFormChange} required style={{width: '100%'}}/>
            </div>
             <div>
               <label>Cán bộ thu mẫu:</label>
               <input type="text" name="can_bo_thu_mau" value={formData.can_bo_thu_mau} onChange={handleFormChange} style={{width: '100%'}}/>
             </div>
             <div>
               <label>SĐT Liên hệ:</label>
               <input type="text" name="sdt_lien_he" value={formData.sdt_lien_he} onChange={handleFormChange} style={{width: '100%'}}/>
             </div>
             <div style={{ gridColumn: 'span 2' }}>
               <label>Đơn vị được thu (Chọn một hoặc nhiều xã):*</label>
               <select 
                 name="cac_xa_id" 
                 multiple 
                 value={formData.cac_xa_id} 
                 onChange={handleFormChange} 
                 required 
                 style={{width: '100%', minHeight: '100px'}} 
               >
                 {xaPhuongList.map(xa => (
                   <option key={xa.id} value={xa.id}>{xa.ten_xa}</option>
                 ))}
               </select>
             </div>
            <div style={{ gridColumn: 'span 4' }}>
              <label>Ghi chú (nếu có):</label>
              <textarea name="ghi_chu" value={formData.ghi_chu} onChange={handleFormChange} style={{ width: '100%' }} />
            </div>
          </div>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <div style={{marginTop: '10px'}}>
            <button type="submit" disabled={isSaving} style={{ background: '#007bff', color: 'white' }}>
              {isSaving ? 'Đang lưu...' : (isEditing ? 'Cập nhật Lịch' : 'Lưu Lịch Mới')}
            </button>
            <button type="button" onClick={cancelForm} style={{ background: 'gray', color: 'white', marginLeft: '10px' }}>
              Hủy
            </button>
          </div>
        </form>
      )}

      {/* (CẬP NHẬT) Bảng hiển thị lịch */}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ background: '#f0f0f0' }}>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Ngày Thu</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Trạm</th> 
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Thời gian</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Địa điểm</th>
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Cán bộ/SĐT</th> 
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Xã được thu</th> 
            <th style={{ padding: '10px', border: '1px solid #ccc' }}>Ghi chú</th>
            {isAdminUser && <th style={{ padding: '10px', border: '1px solid #ccc' }}>Hành động</th>}
          </tr>
        </thead>
        <tbody>
          {lichList.length === 0 ? (
            <tr><td colSpan={isAdminUser ? 8 : 7} style={{ textAlign: 'center', padding: '20px' }}>Chưa có lịch thu mẫu nào.</td></tr>
          ) : (
            lichList.map(lich => (
              <tr key={lich.id}>
                <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                  {formatDate(lich.ngay_thu)} 
                </td>
                <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                  Trạm {lich.tram_thu}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                  {formatTime(lich.gio_bat_dau)} - {formatTime(lich.gio_ket_thuc)}
                </td>
                <td style={{ padding: '10px', border: '1px solid #ccc' }}>{lich.dia_diem}</td>
                <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                   {lich.can_bo_thu_mau && <div>{lich.can_bo_thu_mau}</div>}
                   {lich.sdt_lien_he && <div style={{color: 'blue'}}>{lich.sdt_lien_he}</div>}
                </td>
                 <td style={{ padding: '10px', border: '1px solid #ccc' }}>
                  {/* (*** CẬP NHẬT ***) Sử dụng hàm getXaNames */}
                  {getXaNames(lich.cac_xa_id)} 
                </td>
                <td style={{ padding: '10px', border: '1px solid #ccc' }}>{lich.ghi_chu}</td>
                {isAdminUser && (
                  <td style={{ padding: '10px', border: '1px solid #ccc', textAlign: 'center' }}>
                    <button onClick={() => handleEditClick(lich)} style={{ background: 'orange', color: 'white', marginBottom: '5px' }}>
                      Sửa
                    </button>
                    <button onClick={() => handleDeleteLich(lich.id)} style={{ background: 'red', color: 'white' }}>
                      Xóa
                    </button>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default LichThuMau;

